import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { ClientesService } from './clientes.service';
import { ClientesComponent } from './clientes.component';
import { ClientesDetalleComponent } from './detalle/clientes-detalle.component';
import { ClientesEditarComponent } from './editar/clientes-editar.component';

const routes = [
    {
        path     : 'clientes',
        component: ClientesComponent
    },
    {
        path     : 'clientes/detalle/:idCliente',
        component: ClientesDetalleComponent
    },
    {
        path     : 'clientes/editar/:idCliente',
        component: ClientesEditarComponent
    },
    {
        path     : 'clientes/nuevo',
        component: ClientesEditarComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ClientesComponent,
        ClientesDetalleComponent,
        ClientesEditarComponent
    ],
    providers: [ClientesService]
})
export class ClientesModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/clientes/clientes.module.ts